import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=2856b9c5&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=2856b9c5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856b9c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2856b9c5')) {
      api.createRecord('2856b9c5', component.options)
    } else {
      api.reload('2856b9c5', component.options)
    }
    module.hot.accept("./Cookies.vue?vue&type=template&id=2856b9c5&scoped=true", function () {
      api.rerender('2856b9c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Cookies.vue"
export default component.exports